import { LOGIN_SUCCESS, LOGIN_ERROR, LOGOUT_SUCCESS, LOGOUT_ERROR, UPDATE_USER } from "../../constants/Login";

const initialState = {
    loggedIn: false,
    user: undefined,
    loginError: undefined,
    logoutError: undefined
};

function loginSuccess(state, {user}) {
    return {...state, user, loggedIn: true, loginError: undefined, logoutError: undefined};
}

function loginError(state, {error}) {
    return {...state, loginError: error};
}

function logoutSuccess(state) {
    return {...state, loggedIn:false, user: undefined};
}

function logoutError(state, {error}) {
    return {...state, logoutError: error};
}

function updateUser(state, { user }) {
    return { ...state, user };
}

export default function loginReducer(state= initialState, {type, payload}) {
    switch (type) {
        case LOGIN_SUCCESS:
            return loginSuccess(state, payload);
        case LOGIN_ERROR:
            return loginError(state, payload);
        case LOGOUT_SUCCESS:
            return logoutSuccess(state);
        case LOGOUT_ERROR:
            return logoutError(state, payload);
        case UPDATE_USER:
            return updateUser(state, payload);
        default:
            return state;
    };
};